<script>
    import {gameConfig, isMobile} from '../stores';
    import { autoScrollX } from './actions/autoScrollX.js';

    import ItemSummonMapFort from "./Items/ItemSummonMapFort.svelte";
    import ItemStamina from "./Items/ItemStamina.svelte";
    import ItemToken from "./Items/ItemToken.svelte";
    import ItemResetHeroSkills from "./Items/ItemResetHeroSkills.svelte";
    import ItemResetMarchPreset from "./Items/ItemResetMarchPreset.svelte";
    import ItemInstantLiberationPassPack from "./Items/ItemInstantLiberationPassPack.svelte";
    import ItemMarchRecall from "./Items/ItemMarchRecall.svelte";
    import ItemTroop from "./Items/ItemTroop.svelte";
    import ItemSupplyPart from "./Items/ItemSupplyPart.svelte";
    import ItemEquipmentPart from "./Items/ItemEquipmentPart.svelte";
    import ItemUpgradeScroll from "./Items/ItemUpgradeScroll.svelte";
    import ItemBookOfWar from "./Items/ItemBookOfWar.svelte";
    import ItemMarchSpeedUp from "./Items/ItemMarchSpeedUp.svelte";
    import ItemLootCrateKey from "./Items/ItemLootCrateKey.svelte";
    import ItemVipItem from "./Items/ItemVipItem.svelte";
    import ItemLordXp from "./Items/ItemLordXp.svelte";
    import ItemCommanderTalentParts from "./Items/ItemCommanderTalentParts.svelte";
    import ItemRefreshQuests from "./Items/ItemRefreshQuests.svelte";
    import ItemCommanderRankPoints from "./Items/ItemCommanderRankPoints.svelte";
    import ItemBooster from "./Items/ItemBooster.svelte";
    import ItemTeleport from "./Items/ItemTeleport.svelte";
    import ItemSpeedUp from "./Items/ItemSpeedUp.svelte";
    import ItemResource from "./Items/ItemResource.svelte";
    import ItemGold from './Items/ItemGold.svelte';
    import ItemAllianceGift from './Items/ItemAllianceGift.svelte';
    import ItemCommanderUniversalTalentPart from './Items/ItemCommanderUniversalTalentPart.svelte';
    import ItemUpgradeCastle from "./Items/ItemUpgradeCastle.svelte";
    import ItemInstantResearch from "./Items/ItemInstantResearch.svelte";
    import ItemLootChest from "./Items/ItemLootChest.svelte";
    import ItemLiberationPassPack from "./Items/ItemLiberationPassPack.svelte";
    import '../styles/vars.scss';
    import ItemChangeName from "./Items/ItemChangeName.svelte";
    import ItemGoldenScroll from "./Items/ItemGoldenScroll.svelte";
    import ItemResetCommanderSkills from "./Items/ItemResetCommanderSkills.svelte";
    import ItemPackGameToken from "./Items/ItemPackGameToken.svelte";
    import ItemVanityAvatar from "./Items/ItemVanityAvatar.svelte";
    import ItemVanityFrame from "./Items/ItemVanityFrame.svelte";
    import ItemVanityChat from "./Items/ItemVanityChat.svelte";
    import ItemCastleSkin from "./Items/ItemCastleSkin.svelte";
    import ItemResearchScroll from "./Items/ItemResearchScroll.svelte";
    import ItemTradeMarchCapacityBooster from "./Items/ItemTradeMarchCapacityBooster.svelte";
    import ItemChoiceChest from "./Items/ItemChoiceChest.svelte";
    import ItemAllianceShield from "./Items/ItemAllianceShield.svelte";
    import ItemCardCollectionPack from "./Items/ItemCardCollectionPack.svelte";
    import ItemDoubloons from "./Items/ItemDoubloons.svelte";
    import ItemShipXp from "./Items/ItemShipXp.svelte";
    import ItemBlueprintsChest from "./Items/ItemBlueprintsChest.svelte";
    import ItemShipBlueprint from "./Items/ItemShipBlueprint.svelte";
    import ItemArenaBooster from "./Items/ItemArenaBooster.svelte";
    import {tokenExpiryFallback} from "./token-expiry.js";

    let { storePack, goldAmount = 0, globals = {}, items = [], hasMask = true, areRewards = true, scrollX = false } = $props();
</script>
{#if $gameConfig?.gameItems}
    {#await $gameConfig.gameItems then gameItems}
        <div class={areRewards ? "items" : "rewards"}>
            <div
                    class="{hasMask ? 'mask': ''}"
                    use:autoScrollX={{ group: 'preview-' + (storePack?.internalId ?? storePack?.bundleName ?? 'x'), enabled: scrollX && $isMobile }}
            >
                {#if goldAmount > 0}
                    <ItemGold item=null {goldAmount} itemsAmount={globals.goldItemAmount || 1} bonus={false}/>
                {/if}
                {#if storePack.extraGold}
                    <ItemGold item=null {goldAmount} itemsAmount={globals.goldItemAmount || 1} bonus={true}/>
                {/if}
                {#if items.length > 0}
                    {#each items as item}
                        {@const gameItem = gameItems?.[item.id]}
                        {#if gameItem}
                            {#if gameItem.category === 'resources' || gameItem.category === 'suppliesChest' || gameItem.category === 'equipmentChest' || gameItem.category === 'chest'}
                                <ItemResource
                                        {item}
                                        {gameItem}
                                        {globals}
                                />
                            {:else if gameItem.category === 'gold'}
                                <ItemGold {item} {goldAmount} itemsAmount={item.amount} bonus={false}/>
                            {:else if gameItem.category === 'speedUp'}
                                <ItemSpeedUp
                                        {item}
                                        {gameItem}
                                        {globals}
                                />
                            {:else if gameItem.category === 'teleport'}
                                <ItemTeleport {item} {gameItem}/>
                            {:else if gameItem.category === 'researchSpeedBooster' || gameItem.category === 'gatheringSpeedBooster' || gameItem.category === 'troopHealingSpeedBooster' || gameItem.category === 'troopLoadBooster' || gameItem.category === 'ironProductionBooster' || gameItem.category === 'foodProductionBooster' || gameItem.category === 'stoneProductionBooster' || gameItem.category === 'woodProductionBooster' || gameItem.category === 'silverProductionBooster' || gameItem.category === 'upkeepReductionBooster' || gameItem.category === 'trainingSpeedBooster' || gameItem.category === 'lordXpBooster' || gameItem.category === 'constructionSpeedBooster' || gameItem.category === 'marchSpeedBooster' || gameItem.category === 'antiscoutBooster' || gameItem.category === 'marchSizeBooster' || gameItem.category === 'troopAttackBooster' || gameItem.category === 'troopAttackDebuffBooster' || gameItem.category === 'troopDefenseBooster' || gameItem.category === 'troopDefenseDebuffBooster' || gameItem.category === 'troopHealthBooster' || gameItem.category === 'troopHealthDebuffBooster' || gameItem.category === 'monsterMarchSpeedBooster' || gameItem.category === 'peaceShield' || gameItem.category === 'booster'}
                                <ItemBooster
                                        {item}
                                        {gameItem}
                                        {globals}
                                />
                            {:else if gameItem.category === 'arenaBooster'}
                                <ItemArenaBooster
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'rankPoints'}
                                <ItemCommanderRankPoints
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'refreshMissions'}
                                <ItemRefreshQuests {item} {gameItem}/>
                            {:else if gameItem.category === 'commanderTalentParts'}
                                <ItemCommanderTalentParts
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'lordXp'}
                                <ItemLordXp {item} {gameItem}/>
                            {:else if gameItem.category === 'vipPoints' || gameItem.category === 'vipTime'}
                                <ItemVipItem
                                        {item}
                                        {gameItem}
                                        {globals}
                                />
                            {:else if gameItem.category === 'lootCrateKey'}
                                <ItemLootCrateKey {item} {gameItem}/>
                            {:else if gameItem.category === 'marchSpeedUp'}
                                <ItemMarchSpeedUp {item} {gameItem}/>
                            {:else if gameItem.category === 'bookOfWar'}
                                <ItemBookOfWar {item} {gameItem}/>
                            {:else if gameItem.category === 'upgradeScroll'}
                                <ItemUpgradeScroll {item} {gameItem}/>
                            {:else if gameItem.category === 'equipmentPart'}
                                <ItemEquipmentPart {item} {gameItem}/>
                            {:else if gameItem.category === 'supplyPart'}
                                <ItemSupplyPart {item} {gameItem}/>
                            {:else if gameItem.category === 'troopsItem'}
                                <ItemTroop {item} {gameItem}/>
                            {:else if gameItem.category === 'marchRecall'}
                                <ItemMarchRecall {item} {gameItem}/>
                            {:else if gameItem.category === 'instantLiberationPassPack'}
                                <ItemInstantLiberationPassPack
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'instantLiberationPass'}
                                <ItemInstantLiberationPassPack
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'resetMarchPreset'}
                                <ItemResetMarchPreset
                                        {item}
                                        {gameItem}
                                />
                            {:else if gameItem.category === 'resetHeroSkills'}
                                <ItemResetHeroSkills {item} {gameItem}/>
                            {:else if gameItem.category === 'token'}
                                <ItemToken {item} {gameItem} fallbackExpireAt={tokenExpiryFallback(storePack)}/>
                            {:else if gameItem.category === 'heroStamina'}
                                <ItemStamina {item} {gameItem}/>
                            {:else if gameItem.category === 'fortMap'}
                                <ItemSummonMapFort {item} {gameItem}/>
                            {:else if gameItem.category === 'commanderUniversalTalentParts'}
                                <ItemCommanderUniversalTalentPart {item} {gameItem}/>
                            {:else if gameItem.category === 'instantUpgrade'}
                                <ItemUpgradeCastle {item} {gameItem}/>
                            {:else if gameItem.category === 'instantResearch'}
                                <ItemInstantResearch {item} {gameItem}/>
                            {:else if gameItem.category === 'lootChest'}
                                <ItemLootChest {item} {gameItem}/>
                            {:else if gameItem.category === 'liberationPassPack'}
                                <ItemLiberationPassPack {item} {gameItem}/>
                            {:else if gameItem.category === 'liberationPass'}
                                <ItemLiberationPassPack {item} {gameItem}/>
                            {:else if gameItem.category === 'changeName'}
                                <ItemChangeName {item} {gameItem}/>
                            {:else if gameItem.category === 'goldenScroll'}
                                <ItemGoldenScroll {item} {gameItem}/>
                            {:else if gameItem.category === 'resetCommanderSkills'}
                                <ItemResetCommanderSkills {item} {gameItem}/>
                            {:else if gameItem.category === 'packGameToken'}
                                <ItemPackGameToken {item} {gameItem}/>
                            {:else if gameItem.category === 'vanityAvatar'}
                                <ItemVanityAvatar {item} {gameItem}/>
                            {:else if gameItem.category === 'vanityFrame'}
                                <ItemVanityFrame {item} {gameItem}/>
                            {:else if gameItem.category === 'castleSkin'}
                                <ItemCastleSkin {item} {gameItem}/>
                            {:else if gameItem.category === 'vanityChat'}
                                <ItemVanityChat {item} {gameItem}/>
                            {:else if gameItem.category === 'researchScroll'}
                                <ItemResearchScroll {item} {gameItem}/>
                            {:else if gameItem.category === 'tradeMarchCapacityBooster'}
                                <ItemTradeMarchCapacityBooster {item} {gameItem}/>
                            {:else if gameItem.category === 'choiceChest'}
                                <ItemChoiceChest {item} {gameItem}/>
                            {:else if gameItem.category === 'allianceShield'}
                                <ItemAllianceShield {item} {gameItem} {globals}/>
                            {:else if gameItem.category === 'cardCollectionPack'}
                                <ItemCardCollectionPack {item} {gameItem}/>
                            {:else if gameItem.category === 'doubloons'}
                                <ItemDoubloons {item} {gameItem}/>
                            {:else if gameItem.category === 'shipXp'}
                                <ItemShipXp {item} {gameItem}/>
                            {:else if gameItem.category === 'blueprintsChest'}
                                <ItemBlueprintsChest {item} {gameItem}/>
                            {:else if gameItem.category === 'shipBlueprint'}
                                <ItemShipBlueprint {item} {gameItem}/>
                            {:else if gameItem.category === 'bundle'}
                                {@const bundleItem = gameItems?.[gameItem.itemId]}
                                {#if bundleItem}
                                    {#if bundleItem.category === 'resources' || bundleItem.category === 'suppliesChest' || bundleItem.category === 'equipmentChest' || bundleItem.category === 'chest'}
                                        <ItemResource
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                                {globals}
                                        />
                                    {:else if bundleItem.category === 'gold'}
                                        <ItemGold {item} {goldAmount} itemsAmount={item.amount} bonus={false}/>
                                    {:else if bundleItem.category === 'speedUp'}
                                        <ItemSpeedUp
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                                {globals}
                                        />
                                    {:else if bundleItem.category === 'teleport'}
                                        <ItemTeleport {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'researchSpeedBooster' || bundleItem.category === 'gatheringSpeedBooster' || bundleItem.category === 'troopHealingSpeedBooster' || bundleItem.category === 'troopLoadBooster' || bundleItem.category === 'ironProductionBooster' || bundleItem.category === 'foodProductionBooster' || bundleItem.category === 'stoneProductionBooster' || bundleItem.category === 'woodProductionBooster' || bundleItem.category === 'silverProductionBooster' || bundleItem.category === 'upkeepReductionBooster' || bundleItem.category === 'trainingSpeedBooster' || bundleItem.category === 'lordXpBooster' || bundleItem.category === 'constructionSpeedBooster' || bundleItem.category === 'marchSpeedBooster' || bundleItem.category === 'antiscoutBooster' || bundleItem.category === 'marchSizeBooster' || bundleItem.category === 'troopAttackBooster' || bundleItem.category === 'troopAttackDebuffBooster' || bundleItem.category === 'troopDefenseBooster' || bundleItem.category === 'troopDefenseDebuffBooster' || bundleItem.category === 'troopHealthBooster' || bundleItem.category === 'troopHealthDebuffBooster' || bundleItem.category === 'monsterMarchSpeedBooster' || bundleItem.category === 'peaceShield' || bundleItem.category === 'booster'}
                                        <ItemBooster
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                                {globals}
                                        />
                                    {:else if bundleItem.category === 'arenaBooster'}
                                        <ItemArenaBooster
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'rankPoints'}
                                        <ItemCommanderRankPoints
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'refreshMissions'}
                                        <ItemRefreshQuests {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'commanderTalentParts'}
                                        <ItemCommanderTalentParts
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'lordXp'}
                                        <ItemLordXp {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'vipPoints' || bundleItem.category === 'vipTime'}
                                        <ItemVipItem
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                                {globals}
                                        />
                                    {:else if bundleItem.category === 'lootCrateKey'}
                                        <ItemLootCrateKey {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'marchSpeedUp'}
                                        <ItemMarchSpeedUp {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'bookOfWar'}
                                        <ItemBookOfWar {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'upgradeScroll'}
                                        <ItemUpgradeScroll {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'equipmentPart'}
                                        <ItemEquipmentPart {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'supplyPart'}
                                        <ItemSupplyPart {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'troopsItem'}
                                        <ItemTroop {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'marchRecall'}
                                        <ItemMarchRecall {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'instantLiberationPassPack'}
                                        <ItemInstantLiberationPassPack
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'instantLiberationPass'}
                                        <ItemInstantLiberationPassPack
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'resetMarchPreset'}
                                        <ItemResetMarchPreset
                                                {item}
                                                gameItem={{ ...bundleItem, amount: gameItem.amount }}
                                        />
                                    {:else if bundleItem.category === 'resetHeroSkills'}
                                        <ItemResetHeroSkills {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'token'}
                                        <ItemToken {item} gameItem={{ ...bundleItem, amount: gameItem.amount }} fallbackExpireAt={tokenExpiryFallback(storePack)}/>
                                    {:else if bundleItem.category === 'heroStamina'}
                                        <ItemStamina {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'fortMap'}
                                        <ItemSummonMapFort {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'commanderUniversalTalentParts'}
                                        <ItemCommanderUniversalTalentPart {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'instantUpgrade'}
                                        <ItemUpgradeCastle {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'instantResearch'}
                                        <ItemInstantResearch {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'lootChest'}
                                        <ItemLootChest {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'liberationPassPack'}
                                        <ItemLiberationPassPack {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'liberationPass'}
                                        <ItemLiberationPassPack item={item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'changeName'}
                                        <ItemChangeName {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'goldenScroll'}
                                        <ItemGoldenScroll {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'resetCommanderSkills'}
                                        <ItemResetCommanderSkills {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'packGameToken'}
                                        <ItemPackGameToken {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'vanityAvatar'}
                                        <ItemVanityAvatar {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'vanityFrame'}
                                        <ItemVanityFrame {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'castleSkin'}
                                        <ItemCastleSkin {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'vanityChat'}
                                        <ItemVanityChat {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'researchScroll'}
                                        <ItemResearchScroll {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'tradeMarchCapacityBooster'}
                                        <ItemTradeMarchCapacityBooster {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'bundle'}
                                        <ItemTradeMarchCapacityBooster {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'choiceChest'}
                                        <ItemChoiceChest {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'allianceShield'}
                                        <ItemAllianceShield {item} gameItem={{ ...bundleItem, amount: gameItem.amount }} {globals}/>
                                    {:else if bundleItem.category === 'cardCollectionPack'}
                                        <ItemCardCollectionPack {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'doubloons'}
                                        <ItemDoubloons {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'shipXp'}
                                        <ItemShipXp {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'blueprintsChest'}
                                        <ItemBlueprintsChest {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else if bundleItem.category === 'shipBlueprint'}
                                        <ItemShipBlueprint {item} gameItem={{ ...bundleItem, amount: gameItem.amount }}/>
                                    {:else}
                                        <div class="missing">
                                            Missing item {bundleItem.category} : {item.id}
                                        </div>
                                    {/if}
                                {:else}
                                    <div class="missing">
                                        Missing bundled item id {gameItem.itemId} (from {item.id})
                                    </div>
                                {/if}
                            {:else}
                                <div class="missing">
                                    Missing item {gameItem.category} : {item.id}
                                </div>
                            {/if}
                        {:else}
                            <div class="missing">
                                Missing item id {item.id}
                            </div>
                        {/if}
                    {/each}
                {/if}
                {#if storePack.giftType !== undefined}
                    <ItemAllianceGift {storePack}/>
                {/if}
            </div>
        </div>
    {:catch e}
        Error resolving promise
    {/await}
{/if}

<style lang="scss">
  @use '../styles/vars.scss' as *;

  :global {
    .pack {
      &.goldPacks {
        .items {
          display: block !important;
          position: absolute !important;
          left: -5px !important;
          bottom: 85px !important;
          z-index: 20 !important;
          background: transparent !important;
          padding: 0 !important;
          margin: 0 !important;
          width: auto !important;
          border-radius: 0 !important;

          .mask {
            padding: 0 !important;
            height: auto !important;
            overflow: visible !important;
            mask-image: none !important;
            -webkit-mask-image: none !important;
          }

          .item-title {
            display: none !important;
          }

          .item-amount {
            color: #fff !important;
            position: relative;
            top: 10px;

            &::before {
                content: "x" !important;
            }
          }
        }
      }

      &.resources {
        .items {
          display: none !important;
        }
      }
    }
  }

  .items {
    background-color: rgba(255, 255, 255, 0.2);
    padding: 10px 5px 10px 5px;
    border-radius: 6px;
    margin-top: $store-pack-header-height + 35;
    width: 100%;

    .mask {
      /* scroll bar width, for use in mask calculations */
      --scrollbar-width: 4px;
      --scrollbar-color: rgba(0, 0, 0, 0.2);

      /* mask fade distance, for use in mask calculations */
      --mask-height: 20px;

      /* If content exceeds height of container, overflow! */
      overflow-y: auto;

      /* Our height limit */
      height: $store-pack-height - 320;

      /* Need to make sure container has bottom space,
otherwise content at the bottom is always faded out */
      padding-bottom: var(--mask-height);
      padding-top: 10px;

      /* Keep some space between content and scrollbar */
      padding-right: 10px;

      /* The CSS mask */

      /* The content mask is a linear gradient from top to bottom */
      --mask-image-content: linear-gradient(
                      to bottom,
                      transparent,
                      black var(--mask-height),
                      black calc(100% - var(--mask-height)),
                      transparent
      );

      scrollbar-width: thin; /* can also be normal, or none, to not render scrollbar */
      scrollbar-color: var(--scrollbar-color) transparent; /* foreground background */

      /* Here we scale the content gradient to the width of the container 
minus the scrollbar width. The height is the full container height */
      --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;

      /* The scrollbar mask is a black pixel */
      --mask-image-scrollbar: linear-gradient(black, black);

      /* The width of our black pixel is the width of the scrollbar.
The height is the full container height */
      --mask-size-scrollbar: var(--scrollbar-width) 100%;

      /* Apply the mask image and mask size variables */
      mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
      mask-size: var(--mask-size-content), var(--mask-size-scrollbar);

      /* Position the content gradient in the top left, and the 
scroll gradient in the top right */
      mask-position: 0 0, 100% 0;

      /* We don't repeat our mask images */
      mask-repeat: no-repeat, no-repeat;

      &::-webkit-scrollbar {
        width: var(--scrollbar-width);
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-color);
        border-radius: 9999px; /* always round */
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }

  .rewards {
    background-color: rgba(255, 255, 255, 0.2);
    padding: 10px 5px 10px 5px;
    border-radius: 6px;
    margin-top: 15px;
    width: 100%;

    .mask {
      /* scroll bar width, for use in mask calculations */
      --scrollbar-width: 4px;
      --scrollbar-color: rgba(0, 0, 0, 0.2);

      /* mask fade distance, for use in mask calculations */
      --mask-height: 20px;

      /* If content exceeds height of container, overflow! */
      overflow-y: auto;

      /* Our height limit */
      height: 160px;

      /* Need to make sure container has bottom space,
otherwise content at the bottom is always faded out */
      padding-bottom: var(--mask-height);
      padding-top: 10px;

      /* Keep some space between content and scrollbar */
      padding-right: 10px;

      /* The CSS mask */

      /* The content mask is a linear gradient from top to bottom */
      --mask-image-content: linear-gradient(
                      to bottom,
                      transparent,
                      black var(--mask-height),
                      black calc(100% - var(--mask-height)),
                      transparent
      );

      scrollbar-width: thin; /* can also be normal, or none, to not render scrollbar */
      scrollbar-color: var(--scrollbar-color) transparent; /* foreground background */

      /* Here we scale the content gradient to the width of the container 
minus the scrollbar width. The height is the full container height */
      --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;

      /* The scrollbar mask is a black pixel */
      --mask-image-scrollbar: linear-gradient(black, black);

      /* The width of our black pixel is the width of the scrollbar.
The height is the full container height */
      --mask-size-scrollbar: var(--scrollbar-width) 100%;

      /* Apply the mask image and mask size variables */
      mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
      mask-size: var(--mask-size-content), var(--mask-size-scrollbar);

      /* Position the content gradient in the top left, and the 
scroll gradient in the top right */
      mask-position: 0 0, 100% 0;

      /* We don't repeat our mask images */
      mask-repeat: no-repeat, no-repeat;

      &::-webkit-scrollbar {
        width: var(--scrollbar-width);
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-color);
        border-radius: 9999px; /* always round */
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
</style>